<template>
    <v-tooltip :text="badge.label" location="end">
        <template #activator="{props}">
            <v-chip v-bind="props" :aria-label="badge.label" :color="menuCountColor(badge.severity)"
                    class="ml-1 menu-count-chip" size="x-small" variant="flat">
                {{ badge.count > 99 ? '99+' : badge.count }}
            </v-chip>
        </template>
    </v-tooltip>
</template>

<script setup>
import {menuCountColor} from "@/composables/useMenuCounts";

defineProps({
    // {count, severity, label}
    badge: {type: Object, required: true},
});
</script>
